import axios from 'axios';
import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { baseurl } from '../utility/helper';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Swal from 'sweetalert2';

const PreTestList = () => {
  const roleid =  parseInt(sessionStorage.getItem("userroleId"));
  const chapter_id = sessionStorage.getItem("userchapterId");

  const [filters, setFilters] = useState({
    start_date: new Date(new Date().setDate(new Date().getDate() - 30)), // 30 days ago
    end_date: new Date() // Today
  });
  const [filteredData, setFilteredData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [noData, setNoData] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const tableRef = useRef(null);

  const formatDateTimeIST = (dateStr) => {
    if (!dateStr) return '';

    const date = new Date(dateStr);

    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).formatToParts(date);

    const day = parts.find(p => p.type === 'day').value;
    const month = parts.find(p => p.type === 'month').value;
    const year = parts.find(p => p.type === 'year').value;

    const formattedDate = `${day}-${month}-${year}`;

    const timePart = date.toLocaleTimeString('en-IN', {
      timeZone: 'Asia/Kolkata',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    return `${formattedDate} ${timePart}`;
  };

  const formatDOBIST = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).formatToParts(date);
    const day = parts.find(p => p.type === 'day').value;
    const month = parts.find(p => p.type === 'month').value;
    const year = parts.find(p => p.type === 'year').value;
    const formattedDate = `${day}-${month}-${year}`;
    return `${formattedDate}`;
  };

  const fetchData = async (filters) => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.start_date) {
        queryParams.append('start_date', filters.start_date.toISOString());
      }
      if (filters.end_date) {
        queryParams.append('end_date', filters.end_date.toISOString());
      }

      const response = await axios.get(`${baseurl}/admin/PreTestfiltered?${queryParams.toString()}`);
      const data = response.data;

      // Format dates before returning data
      const formattedData = data.map(test => ({
        ...test,

        // keep original for sorting
        pre_test_datetime_raw: test.pre_test_datetime,

        // formatted for display
        pre_test_datetime: formatDateTimeIST(test.pre_test_datetime),

        dob: formatDOBIST(test.dob),
      }));

      return formattedData;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  };

  const formatDOB = (dob) => {
    if (!dob) return "";
    const date = new Date(dob);

    // Extract YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`;
  };

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    let hours = date.getHours(); // Use getHours for local time
    const minutes = String(date.getMinutes()).padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;

    const formattedTime = `${hours}:${minutes} ${ampm}`;

    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const fetchAndSetData = async () => {
      const data = await fetchData(filters);
      setFilteredData(data);
      setNoData(data.length === 0);
      setShowTable(data.length > 0);
      setHasSearched(true);
    };

    fetchAndSetData();
  }, [filters]); // Fetch data whenever filters change

  useEffect(() => {
    if (hasSearched) {
      if (showTable) {
        $(tableRef.current).DataTable({
          destroy: true,
          dom: 'Blfrtip',
          pageLength: 25,
          lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
          buttons: [
            { extend: 'colvis', className: 'btn btn-primary glyphicon glyphicon-duplicate dttable', columns: ':visible' },
            { extend: 'copyHtml5', className: 'btn btn-primary glyphicon glyphicon-duplicate dttable', exportOptions: { columns: ':visible' } },
            { extend: 'excelHtml5', className: 'btn btn-primary glyphicon glyphicon-duplicate dttable', exportOptions: { columns: ':visible' } },
            { extend: 'csvHtml5', className: 'btn btn-primary glyphicon glyphicon-duplicate dttable', exportOptions: { columns: ':visible' } },
            { extend: 'pdfHtml5', className: 'btn btn-primary glyphicon glyphicon-duplicate dttable', exportOptions: { columns: ':visible' } },
            { extend: 'print', className: 'btn btn-primary glyphicon glyphicon-print dttable', exportOptions: { columns: ':visible' } }
          ],
          data: filteredData,
          columns: [
            { data: null, title: 'Sr.No' },
            { data: 'pre_test_datetime', title: 'Register Date' },
            { data: null, title: 'Name' },
            { data: 'mobile_no', title: 'Mobile No' },
            { data: 'email', title: 'Email' },
            { data: 'gender', title: 'Gender' },
            { data: 'dob', title: 'Date of Birth' },
            // { data: 'edu_level', title: 'Education Level' },
            
          ],
          columnDefs: [
            {
              targets: 0,
              render: (data, type, row, meta) => meta.row + 1,
            },
            {
              targets: 1, // Register Date column
              render: function (data, type, row) {

                // Use raw date for sorting
                if (type === 'sort') {
                  return new Date(row.pre_test_datetime_raw).getTime();
                }

                // Show formatted date
                return data;
              }
            },
            {
              targets: 2,
              render: row => `${row.first_name || ''} ${row.last_name || ''}`
            },
          ],
          initComplete: function () {
            $('.dt-length select').addClass('form-select form-select-sm');
          }
        });
      } else {
        setNoData(true);
        setShowTable(false);
      }
    }

    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy(false);
      }
    };
  }, [hasSearched, showTable, filteredData]);

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setFilters({
      ...filters,
      start_date: start,
      end_date: end
    });
  };

  // ── Search button: show a "please wait" modal for the duration of the
  //    fetch, and close it once the new data has been set (the table effect
  //    above then rebuilds the DataTable from that state on its own).
  const handleSearch = async () => {
    Swal.fire({
      title: 'Please wait...',
      text: 'Fetching pre-test registrations',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });

    try {
      const data = await fetchData(filters);
      setFilteredData(data);
      setNoData(data.length === 0);
      setShowTable(data.length > 0);
      setHasSearched(true);
    } finally {
      Swal.close();
    }
  };

  return (
    <div className="container mt-4">
      <div className="profile-section">
        <h2 style={{ textAlign: 'center' }}>Pre-Test Registration List</h2>
        <br />
        <div className="filters row">
          <div className='col-md-4' style={{ zIndex: "40" }}>
            <label>Select Date:</label>&nbsp;
            <DatePicker
              style={{ width: '50%', cursor: 'pointer' }}
              selected={filters.start_date}
              onChange={handleDateChange}
              startDate={filters.start_date}
              endDate={filters.end_date}
              selectsRange
              dateFormat="dd-MM-yyyy"
              className="form-control"
              placeholderText="Select a date range"
            />
          </div>
          <div className='col-md-4'>
            <button style={{borderRadius:'8px'}} onClick={handleSearch}>Search</button>
          </div>
        </div>
        <br />
        <hr />
        <br />
        {!hasSearched ? (
          <h1 style={{ textAlign: 'center' }}>Please perform a search to view data.</h1>
        ) : noData ? (
          <h1 style={{ textAlign: 'center' }}>No Data Available</h1>
        ) : (
          <div className="table-container" style={{ overflowX: 'auto' }}>
            <table id="reports" className="table table-striped table-bordered" ref={tableRef} style={{ overflowX: 'scroll' }}>
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Register Date</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>Gender</th>
                  <th>DOB</th>
                  {/* <th>Education Level</th> */}
                  
                </tr>
              </thead>
              <tbody>
                {/* Data will be populated by DataTables */}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default PreTestList;